import { render, staticRenderFns } from "./IndustryToInterests.vue?vue&type=template&id=22b50f4b&"
import script from "./IndustryToInterests.vue?vue&type=script&lang=ts&"
export * from "./IndustryToInterests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectInput: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/inputs/SelectInput.vue').default})
